import {create} from 'zustand';
import Cookies from 'js-cookie';
import {$api} from 'shared/api';
import type {ApiariesResponse, GetApiariesParams, IApiariesStore} from './types';
import {ApiaryType} from 'shared/types';
import {serializeParams} from 'shared/helpers/converters';
import {useUserStore} from 'entities/user';

const COOKIE_KEY = 'current_apiary_id';
const SHARE_HOST = '';

export const useApiariesStore = create<IApiariesStore>()((set, get) => ({
  apiaries: [],
  currentApiaryId: null,
  currentApiaryVar: null,
  isModalOpen: false,
  shareOffers: [],

  setCurrentApiary: (id) => {
    const {apiaries} = get();

    if (id) {
      Cookies.set(COOKIE_KEY, id, {sameSite: 'lax', expires: 365});
      set({currentApiaryId: id, currentApiaryVar: apiaries.find((a) => a.id === id) ?? null});
    } else {
      Cookies.remove(COOKIE_KEY);
      set({currentApiaryId: null, currentApiaryVar: null});
    }

    useUserStore.getState().setIAmAdmin();
  },

  currentApiary: () => {
    const {apiaries, currentApiaryId} = get();
    if (!currentApiaryId) return null;
    return apiaries.find((a) => a.id === currentApiaryId) ?? null;
  },

  apiariesWithFlag: () => {
    const {apiaries, currentApiaryId} = get();
    return apiaries.map((a) => ({...a, isCurrent: a.id === currentApiaryId}));
  },

  getApiaries: async (userId) => {
    const params: GetApiariesParams = {};
    if (userId) {
      params.owners = userId;
      params.participants = userId;
    }
    params.page = {
      index: 0,
      size: 150,
    };

    const res = await $api.get<ApiariesResponse>('/apiaries', {
      params,
      paramsSerializer: {serialize: serializeParams},
    });
    const items: ApiaryType[] = res.data?.items ?? [];

    const cookieId = Cookies.get(COOKIE_KEY) || null;

    let nextId: string | null = null;

    if (items.length === 0) {
      Cookies.remove(COOKIE_KEY);
      nextId = null;
    } else if (cookieId && items.some((a) => a.id === cookieId)) {
      nextId = cookieId; // cookie валиден
    } else {
      nextId = items[0].id; // авто-выбор первой
      Cookies.set(COOKIE_KEY, nextId, {sameSite: 'lax', expires: 365});
    }

    // Сохраняем список и ЕДИНСТВЕННЫЙ выбранный id
    set({
      apiaries: items,
      currentApiaryId: nextId,
      currentApiaryVar: items.find((a) => a.id === nextId) ?? null,
    });
  },

  getCurrentApiaryId: () => {
    const {currentApiaryId} = get();
    return currentApiaryId;
  },

  getApiariesList: () => {
    const {apiaries} = get();

    return apiaries;
  },
  addApiary: async (params) => {
    const paramsClone = structuredClone?.(params) || JSON.parse(JSON.stringify(params));

    paramsClone.number = 1;

    const res = $api.post('/apiaries', paramsClone);

    return res;
  },
  editApiary: async (params, apiary_id) => {
    const paramsClone = structuredClone?.(params) || JSON.parse(JSON.stringify(params));

    paramsClone.number = 1;

    const res = $api.put(`/apiaries/${apiary_id}`, paramsClone);

    return res;
  },
  addParticipant: async (participantId) => {
    const {currentApiaryId} = get();
    let answer = true;
    await $api
      .post(`/invites`, {
        apiaryId: currentApiaryId,
        userId: participantId,
      })
      .catch((err) => {
        console.warn(err);
        answer = false;
      });

    return answer;
  },

  deleteParticipant: async (participantId) => {
    const {currentApiaryId} = get();
    let answer = true;
    await $api
      .delete(`/apiaries/${currentApiaryId}/participants`, {
        data: {
          participantId,
        },
      })
      .catch((err) => {
        console.warn(err);
        answer = false;
      });

    return answer;
  },
  setIsModalOpen: (val) => {
    set({
      isModalOpen: val || false,
    });
  },

  getShareOffers: async () => {
    const res = await $api
      .get(SHARE_HOST + '/bee-share/offers', {
        params: {
          page: 1,
          limit: 2000,
        },
      })
      .catch(console.warn);

    const shareOffers = res?.data?.items ?? [];

    set({
      shareOffers,
    });
  },
}));
